import { Endpoint } from '../endpoint';

export const SourceFieldMapping = new Endpoint('source_field_mapping');
